import { ariaDescribedByIds, enumOptionsIsSelected, enumOptionsValueForIndex } from '@rjsf/utils';
import { useCallback } from 'react';

import OcRadioButton from '../../ComponentLibrary/input-elements/oc-radio-button';

const RadioWidget = ({
  options,
  value,
  required,
  disabled,
  readonly,
  autofocus = false,
  onBlur,
  onFocus,
  onChange,
  id,
}) => {
  const { enumOptions, enumDisabled, emptyValue } = options;

  const handleBlur = useCallback(
    ({ target }) => onBlur(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)),
    [onBlur, id]
  );

  const handleFocus = useCallback(
    ({ target }) => onFocus(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)),
    [onFocus, id]
  );

  return (
    <div className="field-radio-group" id={id}>
      {Array.isArray(enumOptions) &&
        enumOptions.map((option, i) => {
          const checked = enumOptionsIsSelected(option.value, value);
          const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
          const handleChange = () => onChange(option.value);

          return (
            <OcRadioButton
              key={i}
              value={String(i)}
              checked={checked}
              name={id}
              required={required}
              disabled={disabled || itemDisabled || readonly}
              autoFocus={autofocus && i === 0}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              labelLeft={false}
              aria-describedby={ariaDescribedByIds(id)}
            >
              <span>{option.label}</span>
            </OcRadioButton>
          );
        })}
    </div>
  );
};

export default RadioWidget;
